import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { get, post } from "../../../utils/HttpRequest";
import config from "../../../config/config.json";
import { Toast } from "primereact/toast";
import { Button, Form } from "react-bootstrap";

const ProtocolVersion = () => {
  const toast = useRef(null);
  const formRef = useRef();
  const [validated, setValidated] = useState(false);

  const [protocolVersion, setProtocolVersion] = useState("");
  const [group, setgroup] = useState("");

  const gettrialTitle = async () => {
    try {
      const url = config.api.url + "getTrialConfig/trialVersion";
      get(url).then((response) => {
        let valueData = response.data;
        setProtocolVersion(valueData.value);
        setgroup(valueData.group);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    gettrialTitle();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      event.stopPropagation();
      return;
    }
    try {
      const formData = {
        name: group,
        value: form.protocolVersion.value,
      };
      var url = config.api.url + "updateTrialConfig";
      post(url, formData).then((response) => {
        if (response.status === 201 || response.status === 200) {
          toast.current.show({
            severity: "success",
            summary: "trialVersion has been update",
            detail: "Success",
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "something want wrong",
            detail: "something want wrong",
          });
        }
      });

      setValidated(false);
    } catch (error) {
      console.error("Error making API call:", error);
    }
  };
  return (
    <div className="app">
      <Toast ref={toast}></Toast>
      <hr />
      <span className="card-title">Protocol Version</span>{" "}
      <Form
        className="needs-validation"
        onSubmit={handleSubmit}
        noValidate
        ref={formRef}
        validated={validated}
      >
        <div className="col-sm-12 col-md-2 mb-3 mt-3">
          <Form.Group>
            <Form.Control
              type="text"
              className="form-control input-group"
              name="protocolVersion"
              rows="4"
              required
              value={protocolVersion}
              onChange={(e) => setProtocolVersion(e.target.value)}
            />
          </Form.Group>
        </div>

        <div className="form-actions ml-2 mb-4">
          <Button className="btn btn-primary  px-3" type="submit">
            Save
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default ProtocolVersion;
